import Stringer from "@/packages/stringer/src/Stringer";

export default class StringerCollection {
	values = [];

	constructor(strings) {
		strings.forEach((string, key) => {
			this.values[key] = string instanceof Stringer ? string : new Stringer(string);
		});
		return this;
	}

	get value() {
		return this.join();
	}

	join(string = "", last = null) {
		if (!last) {
			return new Stringer(this.all().join(string));
		}
		return this.map((stringer, key) => {
			if (key === this.all().length - 1) {
				return stringer;
			}
			console.log(stringer, key, this.all().length);
			let joinString = string;
			if (key === this.all().length - 2) {
				joinString = last;
			}
			return stringer.append(joinString);
		}).join("");
		return new Stringer(this.all().join(string));
	}

	get(index) {
		return this.values[index];
	}

	all() {
		return this.values.map(value => value.value);
	}

	map() {
		let args = Array.from(arguments);
		let method = args.shift();
		this.values.forEach((stringer, key) => {
			this.values[key] = typeof method === "function" ? stringer.map(method, key) : stringer[method](...args);
		});
		return this;
	}
}
